<template>
  <div>
    <v-toolbar>
      <v-container fluid>
        <div class="d-flex align-center">
          <back />
          <h3 class="ml-5 primary--text">
            <portal-target name="WorkloadHeaderLeftSide" />
          </h3>
          <v-spacer />
          <portal-target name="WorkloadHeaderRightSide" />
        </div>
      </v-container>
    </v-toolbar>

    <v-container
      class="mt-5"
      fluid
    >
      <router-view />
    </v-container>
  </div>
</template>

<script>
    import Back from "@/components/atoms/Back";
    import Me from "@/mixins/Me";

    export default {
        name: "BaseWorkload",
        components: {
            Back
        },
        mixins: [
            Me
        ],
        mounted() {
            this.awaitPromiseCallback({
                key: 'getMe', cb: () => {
                    if (!this.HaveAccessToWorkload) {
                        this.$router.push({name: 'Home'})
                    }
                }
            })
        },
    }
</script>

<style scoped>

</style>
